import React from 'react';
import { Landmark, Award, Star, ArrowUpRight } from 'lucide-react';
import Reveal from '../Reveal';

export default function CameraDeputatiSection() {
  return (
    <section
      id="camera-dei-deputati"
      data-testid="camera-deputati-section"
      data-advisor-target="camera"
      className="py-20 md:py-28 border-y border-white/8 relative overflow-hidden bg-[#0a1230]"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 grid-bg opacity-20" />
        <div className="absolute -top-20 -left-24 w-[520px] h-[520px] rounded-full bg-lime/10 blur-[120px]" />
        <div className="absolute -bottom-20 -right-24 w-[520px] h-[520px] rounded-full bg-cyan-400/10 blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <Reveal>
          <div className="flex flex-col items-center text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass mb-5">
              <Landmark size={14} className="text-lime" />
              <span className="text-white/80 text-xs font-mono-t">_premio stelle di E.S.S.E. · Roma</span>
            </span>
            <h2 className="font-display font-bold text-3xl md:text-5xl text-white leading-tight max-w-3xl mb-5">
              La nostra testimonianza alla <span className="gradient-text">Camera dei Deputati</span>
            </h2>
            <p className="text-white/70 text-lg max-w-2xl">
              Il CEO di Digital Tech Solutions e A.C.D.T. ha portato la nostra visione del mondo digitale all interno delle istituzioni, ricevendo il riconoscimento "La Stella di E.S.S.E." per il contributo all innovazione digitale e sostenibile.
            </p>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div
            className="relative rounded-3xl overflow-hidden border-2 border-lime/25 shadow-2xl bg-black mb-10"
            style={{ aspectRatio: '16 / 9' }}
            data-testid="camera-deputati-video"
          >
            <video
              controls
              preload="metadata"
              poster="/img/press/camera-dei-deputati-1.jpg"
              className="w-full h-full object-cover"
            >
              <source src="/video/camera-dei-deputati.mp4" type="video/mp4" />
              Il tuo browser non supporta la riproduzione video.
            </video>
          </div>
        </Reveal>

        {/* Photo gallery with ACDT + DTS logo overlays */}
        <div className="grid md:grid-cols-2 gap-5 md:gap-6" data-testid="camera-deputati-gallery">
          {['/img/press/camera-dei-deputati-1.jpg', '/img/press/camera-dei-deputati-2.jpg'].map((src, i) => (
            <Reveal key={src} delay={150 + i * 100}>
              <div className="group relative rounded-3xl overflow-hidden border border-white/10 bg-black">
                <img
                  src={src}
                  alt={`Camera dei Deputati - foto ${i + 1}`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  style={{ aspectRatio: '3 / 2' }}
                />
                {/* Dual logo overlay (top-right) */}
                <div className="absolute top-4 right-4 flex items-center gap-2">
                  <div className="h-12 w-12 rounded-xl bg-white/95 shadow-lg flex items-center justify-center p-1.5" title="A.C.D.T.">
                    <img src="/img/logos/acdt.jpg" alt="A.C.D.T." className="w-full h-full object-contain" />
                  </div>
                  <div className="h-12 w-12 rounded-xl bg-white/95 shadow-lg flex items-center justify-center p-1" title="Digital Tech Solutions">
                    <img src="/img/logos/dts.png" alt="Digital Tech Solutions" className="w-full h-full object-contain" />
                  </div>
                </div>
                {/* Bottom gradient + caption */}
                <div className="absolute inset-x-0 bottom-0 pt-16 pb-5 px-5" style={{ background: 'linear-gradient(180deg, transparent 0%, rgba(7,7,10,0.9) 85%)' }}>
                  <p className="text-white font-display font-semibold text-sm md:text-base">
                    {i === 0 ? 'Consegna del premio "La Stella di E.S.S.E." al CEO di DTS' : 'Riconoscimento ufficiale "La Stella di E.S.S.E." - Giugno 2024, Roma'}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Stats row */}
        <Reveal delay={300}>
          <div className="grid grid-cols-3 gap-4 md:gap-6 mt-12 max-w-3xl mx-auto">
            {[
              { icon: Landmark, label: 'Camera dei Deputati', value: 'Roma' },
              { icon: Award, label: 'Riconoscimento', value: 'La Stella di E.S.S.E.' },
              { icon: Star, label: 'Promosso da', value: 'Ente Sportivo Sociale Europeo' },
            ].map((s) => (
              <div key={s.label} className="glass rounded-2xl p-4 md:p-5 text-center">
                <s.icon size={18} className="text-lime mx-auto mb-2" />
                <p className="text-white/50 text-xs mb-1">{s.label}</p>
                <p className="text-white font-display font-bold text-sm md:text-base leading-tight">{s.value}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
